export default {
  modelName: 'external_training_template',
  label: '外訓公版',
  fields: {
    area: {
      type: 'belongsTo',
      label: '地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    statitory_extension_period: {
      type: 'number',
      label: '幾日前展延提醒',
      maxlength: 10,
    },
    recommend_notify_period: {
      type: 'number',
      label: '建議展延前幾日提醒',
      maxlength: 10,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 200,
        },
        precautions: {
          type: 'textarea',
          label: '注意事項',
          maxlength: 1000,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    system_class: {
      type: 'belongsTo',
      label: '領域',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_class',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_class',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    industry_categories: {
      label: '適用產業別',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'industry_category',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    articles: {
      label: '相關法條',
      type: 'hasMany',
      textKey: 'last_version.no_text',
      modelName: 'article',
      getText: (item) => {
        if (!item.last_version) {
          return null;
        } else {
          return `${item.act_version.name}-${item.last_version.no_text}`;
        }
      },
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};
